// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2zbDz","name":"ConsentHeader_name__W8mrn","birthday":"ConsentHeader_birthday__2C2W3","skeleton":"ConsentHeader_skeleton__1lOng"};